(ns com.theplantscape.web-ui.tailwind.ensemble
  (:require [com.theplantscape.web-ui.tailwind.buttons :as btn]
            [com.theplantscape.web-ui.tailwind.banner :as banner]
            [com.theplantscape.web-ui.tailwind.gps :as gps]
            [com.theplantscape.web-ui.tailwind.grids :as grids]
            [com.theplantscape.web-ui.tailwind.images :as i]
            [com.theplantscape.web-ui.tailwind.command-dialog :as cmd]
            [com.theplantscape.web-ui.tailwind.lists :as list]
            [com.theplantscape.web-ui.tailwind.modal :as m]
            [com.theplantscape.web-ui.tailwind.info-tile :as tile]
            [com.theplantscape.web-ui.tailwind.colour-picker :as cp]
            [com.theplantscape.web-ui.tailwind.toolbar :as tb]
            [com.theplantscape.web-ui.tailwind.not-found :as nf]
            [com.theplantscape.web-ui.tailwind.form.elements.form :as f]
            [com.theplantscape.web-ui.tailwind.form.elements.input :as fi]
            [com.theplantscape.web-ui.tailwind.form.elements.checkbox :as fc]))

(defn ui-stat-tile [cfg]
  (tile/ui-stat-tile cfg))

(defn form
  ([body] (form {} body))
  ([cfg body] (f/form cfg body)))

(defn select-tool [tools]
  (cmd/select-tool tools))

(defn simple-list
  ([items] (simple-list items #(str %)))
  ([items formatter]
   (list/simple-list items formatter)))

(defn ui-btn-action [text callback]
  (btn/ui-btn-action text callback))

(defn ui-btn-link [opts]
  (btn/ui-btn-link opts))

(defn btn-add-new-plant []
  (btn/btn-add-new-plant))

(defn ui-btn-toggle [state update-fn]
  (btn/ui-btn-toggle state update-fn))

(defn icon-toolbar [icons]
  (tb/icon-toolbar icons))

(defn simple-modal [cfg]
  (m/simple-modal cfg))

(defn colour-picker [fn-callback]
  (cp/colour-picker fn-callback))

(defn picture [cfg]
  (i/picture cfg))

(defn ui-missing [body]

  (nf/ui-missing body))

(defn ui-gps-coordinates [value cfg]
  (fi/ui-gps-coordinates value cfg))

(defn ui-gps-coordinates-fn [value cfg]
  (fi/ui-gps-coordinates-fn value cfg))

(defn ui-form-boolean [value cfg]
  (fc/ui-form-boolean value cfg))

(defn ui-form-checkbox [value cfg]
  (fc/ui-form-checkbox value cfg))

(defn ui-form-checkbox-fn [ cfg]
  (fc/ui-form-checkbox-fn cfg))

(defn ui-compass-popup [cfg]
  (gps/ui-compass-popup cfg))

(defn grid-layout
  ([items] (grids/grid-layout 3 items))
  ([size items] (grids/grid-layout size items)))

(defn grid-layout-one
  ([content items] (grids/grid-layout-one 3 content items))
  ([size content items] (grids/grid-layout-one size content items)))

(defn hero-banner [content]
  (banner/hero-banner content))
